import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import { CreditCardDisplay } from 'ggx-componentlibrary/components/credit-card-display/credit-card-display.component'
import {
  StyledCreditCardGroup,
  ReadOnlyCreditCardContainer,
} from './credit-card.component.styles'
import { getSavedCard } from '../duck/selectors'

const CreditCard = ({ input, meta, readOnlyCreditCardInfo }) => {
  const savedCard = useSelector(state => getSavedCard(state))

  useEffect(() => {
    input.onChange(savedCard)
  }, [savedCard])

  const { touched, error } = meta
  const metaError = touched && error !== undefined ? { code: error } : null

  if (readOnlyCreditCardInfo) {
    return (
      <ReadOnlyCreditCardContainer>
        <CreditCardDisplay
          brand={readOnlyCreditCardInfo.brand}
          number={readOnlyCreditCardInfo.last4}
          noBorderDisplayMode
        />
      </ReadOnlyCreditCardContainer>
    )
  }

  return <StyledCreditCardGroup metaError={metaError} />
}

CreditCard.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string.isRequired,
  }),
  readOnlyCreditCardInfo: PropTypes.shape({
    brand: PropTypes.string.isRequired,
    number: PropTypes.string.isRequired,
  }),
}

export { CreditCard }
